import type { ChatPublicEvent } from '../../shared/types'

export const emitEvent = (event: ChatPublicEvent) => {
  if (window.ChiliChat?.config.eventsHandler) {
    try {
      window.ChiliChat.config.eventsHandler(event)
    } catch (error) {
      console.error(`Error calling window.ChiliChat.config.eventsHandler`, event, error)
    }
  }
}
